/**
 * Metadata fields used for housekeeping that always accompany real edits (authorship/timestamps),
 * but do not add value without other edits.
 */
const metadataKeys = new Set([
  'author',
  'createdTime',
  'lastLocalChange',
  'lastSavedChange',
  'timeAddedToFlow',
  'updatedTime'
]);

export function isMetadataKeyPath(key: readonly string[]): boolean {
  const lastKey = key[key.length - 1];
  return (
    metadataKeys.has(lastKey)
    && (
      // Catch top level metadata fields like @see DesignAppProperty.lastLocalChange.
      key.length === 1
      // Catch metadata nested under `props` like DesignModuleNode.props.author.
      || (key.length === 2 && key[0] === 'props')
      // Catch metadata nested under `props` of module local variables DesignModuleLocalVariable.props.author.
      || (
        key.length === 4
        && key[0] === 'localVariables'
        && key[2] === 'props'
      )
    )
  );
}
